export default {
    resetStateMutation() {}
}
